"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ElastiCacheFactoryServiceNS = void 0;
var ElastiCacheFactoryServiceNS;
(function (ElastiCacheFactoryServiceNS) {
    ElastiCacheFactoryServiceNS.ELASTI_CACHE_FACTORY_SERVICE_ID = Symbol.for("ElastiCacheFactoryService");
})(ElastiCacheFactoryServiceNS = exports.ElastiCacheFactoryServiceNS || (exports.ElastiCacheFactoryServiceNS = {}));
//# sourceMappingURL=elasticache-redis.types.js.map